import 'whatwg-fetch';
import Promise from 'bluebird';
window.Promise = Promise;
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import ClickBack from './components/userActions/ClickBack';
import Postal from './components/linkOuts/Postal';
import CustomerService from './components/linkOuts/CustomerService';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import {constants} from './utils/constants';
import appReducer from './reducers/app';
import TranslationStore from './stores/TranslationStore';
import {callTealiumLink, deleteCountryCookie, determineLegalCountry} from './utils/helpers';

import createTelemetryService from "./telemetry/telemetryInit";
const ts = createTelemetryService({ component: "Login" });

const Provider = require('react-redux').Provider;
const connect = require('react-redux').connect;

const createStore = require('./stores/redux');
const store = createStore(appReducer);

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const legalCountry = determineLegalCountry();
    ts.info("componentDidMount-props", {
      action: constants.telemetry.actions.componentDidMount,
      legalCountry,
    });

    if (legalCountry && legalCountry !== 'none' && legalCountry !== 'US') {
      deleteCountryCookie();
    }
  }

  render() {
    const state = store.getState().app;

    return (
      <div className='comp comp-app'>
        <Header />
        <div className='main-content'>
          <ClickBack hasClickbackSuccess={state.hasClickbackSuccess} hasClickbackFailure={state.hasClickbackFailure} dispatch={store.dispatch} email={state.email}/>
          <span hidden={state.hasClickbackSuccess && !state.hasClickbackFailure}>
            <span hidden={state.location !== 'US' && state.location !== 'CA'}>
              <Postal />
            </span>
            <CustomerService />
          </span>
        </div>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func,
  store: PropTypes.object,
  email: PropTypes.string,
  hasClickbackSuccess: PropTypes.bool,
  hasClickbackFailure: PropTypes.bool
};

const ConnectedApp = connect((state) => {
  return state.app;
})(App);

// LOGIN EVENT
window.did.on('login', function() {
  ts.info("On-Login", { action: constants.telemetry.actions.didOnLogin });
  if (window.pageName === 'login') {
    var queryParams;
    if (window.location.href.includes('?')) {
      let urlParams = window.location.href.split('/');
      let params = urlParams[urlParams.length - 1].split(/\?/g)[1];
      if (params.includes('sessionTransferKey')){
        params = params.split('&');
        _.remove(params, function(n) {
          return n.includes('sessionTransferKey');
        });
        params = _.join(params, '&');
      }
      if (!params.includes('login')){
        queryParams = `?login=true&${params}`;
      } else {
        queryParams = `?${params}`;
      }
    } else {
      queryParams = '?login=true';
    }
    let href = `${window.location.origin}/manage/email/${window.langPref}${queryParams}`;
    window.location.href = href;
  }
});

// CLOSE EVENT
window.did.on('close', function() {
  ts.info("On-Close", { action: constants.telemetry.actions.didOnClose });
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
  document.getElementById('scrollContainer').className = "";
});

// ERROR EVENT
window.did.on('error', function (data) {
  ts.info("On-Error", { action: constants.telemetry.actions.didOnError });
  console.log('Looks like there was a DID problem. ', data);
});

// INIT
window.did.init().then(function (data) {
  ts.info("DID-Init", {action: constants.telemetry.actions.didInitialized});

  //parse query string params
  let queryParams;
  if (window.location.href.includes('?')) {
    let urlParams = window.location.href.split('/');
    queryParams = urlParams[urlParams.length - 1].split(/\?|&/g).slice(1);
  }
  var key = '';
  var params = '?login=true';
  _.forEach(queryParams, function(param, index){
    if (param.includes('sessionTransferKey')) {
      key = param.split('=')[1];
      key = decodeURIComponent(key);
      //don't include login param
    } else if (!param.includes('login')){
      params += `&${param}`;
    }
  });

  if (data.loggedIn) {
    if (key.length > 1) {
      window.did.logout().then(function(){
        window.did.redeemSessionTransferKey(key).then(function (guest) {
          // Session transfer complete
          // 'login' event emitted
          callTealiumLink({login: constants.loginTypes.sessionTransfer});
        }, function (errorCode) {
          // Failed to transfer session
          console.log('Looks like there was a problem transferring your session. ', data);
          let href = `${window.location.origin}/${window.langPref}`;
          window.location.href = href;
        });
      }, function(error){
        console.log('Looks like there was a problem logging out. ', data);
      });
    } else if (window.pageName === 'login') {
      let href = `${window.location.origin}/manage/email${params}`;
      window.location.href = href;
      callTealiumLink({login: constants.loginTypes.lightbox});
    }
  } else if (key.length > 1 && !data.loggedIn) {
    window.did.redeemSessionTransferKey(key).then(function (guest) {
      // Session transfer complete
      // 'login' event emitted
      callTealiumLink({login: constants.loginTypes.sessionTransfer});
    }, function (errorCode) {
      // Failed to transfer session
      console.log('Looks like there was a problem transferring your session. ', data);
      let href = `${window.location.origin}/${window.langPref}`;
      window.location.href = href;
    });
  } else {
    // load default strings
    TranslationStore.setAvailableLanguages(constants.availableLanguages);

    let langPref = window.langPref;
    let fetchString = '/translations/' + langPref + '.json';

    fetch(fetchString)
      .then(response => response.json())
      .then(function (json) {
        TranslationStore.setLanguage(langPref, json);
        ReactDOM.render(
          <Provider store={store}>
            <ConnectedApp />
          </Provider>,
          document.getElementById('app')
        );
      });
  }
}).catch(function (error) {
  console.log('Could not initialize OneID', error);
  // load default strings
  TranslationStore.setAvailableLanguages(constants.availableLanguages);

  let langPref = window.langPref;
  let fetchString = '/translations/' + langPref + '.json';

  fetch(fetchString)
    .then(response => response.json())
    .then(function (json) {
      ts.info("Translations-fetched", {
        action: constants.telemetry.actions.translationsFetched,
        langPref,
      });
      TranslationStore.setLanguage(langPref, json);
      ReactDOM.render(
        <Provider store={store}>
          <ConnectedApp />
        </Provider>,
        document.getElementById('app')
      );
    });
});



// WEBPACK FOOTER //
// ./client/src/login.jsx